import { makeRemoteGetQueueAttachment } from 'main/factories/usecases/queue/remote-get-queue-attachment';
import { Attachment } from 'presentation/components/Queue/Chat/Chat';
import { transformFileType } from 'presentation/components/Queue/utils/fileUtils';

export const getQueueAttachmentBlob = async (attachment: Attachment): Promise<Blob | undefined> => {
  const service = makeRemoteGetQueueAttachment(attachment.attachmentId);
  const response = await service.get();
  const mimeType = transformFileType(attachment.fileType);

  if (typeof response === 'string') {
    if (response.startsWith('data:')) {
      return fetch(response).then(res => res.blob());
    }

    if (/^[A-Za-z0-9+/=]+$/.test(response)) {
      const binary = atob(response);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      return new Blob([bytes], { type: mimeType });
    }

    return new Blob([response], { type: mimeType });
  }

  return new Blob([response as BlobPart], { type: mimeType });
};
